import { Grid } from "@mui/material";
import styles from 'assets/css/BarChartStyle.module.css';
import { digitsEnToFa } from "persian-tools2";

export const BarChartFooter = (props) => {
    const { allGlucoseCount, averageGlucose } = props;
    return (
        <Grid container className={styles.footerContainer}>
            <Grid item xs={6} display='flex' justifyContent='end'>
                <span className={styles.totalText}>
                    <p>  میانگین کل:   </p>
                </span>
            </Grid>
            <Grid item xs={6} display='flex' justifyContent='start'>
                <span style={{paddingRight:'10px'}} className={styles.totalValue}>mg/dl</span>
                <span style={{paddingRight:'5px'}} className={styles.totalValue}>
                    {isNaN(averageGlucose / allGlucoseCount) ? digitsEnToFa('0') :
                        ` ${digitsEnToFa(Math.round(averageGlucose / allGlucoseCount))}`}
                </span>
            </Grid>
        </Grid>
    );
};